import Vue from 'vue'
import Router from 'vue-router'
//个人中心
const Center = () => import('@/views/center/index')
//风险测评
const Ass = () => import('@/views/assessment/index')
//成长
const Growth = () => import('@/views/growth/growth')
//成长视频
const Videoplayer = () => import('@/views/growth/videoplayer')
// 专家服务-导航页
import expertAnalyse from '@/views/TingSheng/expertAnalyse.vue';
// 专家服务-主页
const expertService = () => import('@/views/TingSheng/expertService.vue')
// 专家服务-观点直播
const viewpointLive = () => import('@/views/TingSheng/viewpointLive.vue')
// 专家服务-观点直播-视频
const viewpointVideo = () => import('@/views/TingSheng/viewpointVideo.vue')
// 专家服务-观点直播-图片
const viewpointImage = () => import('@/views/TingSheng/viewpointImage.vue')
// 专家服务-早知晓FM
const earlyKnow = () => import('@/views/TingSheng/earlyKnow.vue')
// 专家服务-主页
const expertServiceMain = () => import('@/views/TingSheng/expertServiceMain.vue')
// 专家在线
const expertOnline = () => import('@/views/TingSheng/expertOnline.vue')
// 专家在线
const myQuesAnsw = () => import('@/views/TingSheng/myQuesAnsw.vue')
// 提问-课程推荐
const classRecommend = () => import('@/views/TingSheng/classRecommend.vue')
// 提问-提交问题
const submitQues = () => import('@/views/TingSheng/submitQues.vue')
//自选股资讯
const information = () => import('@/views/information/information')
//研报策略
const ybcl = () => import('@/views/strategy/ybcl')
// 直播课堂-列表
const liveLesson = () => import('@/views/TingSheng/liveLesson.vue')
// 解盘视频-往期回顾
const historyLesson = () => import('@/views/TingSheng/historyLesson.vue')
// 解盘视频-往期回顾
const liveLessonPlay = () => import('@/views/TingSheng/liveLessonPlay.vue')
//策略顶部公共部分
const selComponent = () => import('@/views/strategy/selComponent')
// 专家提问-问答协议
const askProtocol = () => import('@/views/TingSheng/askProtocol.vue')
// 专家服务-热点聚焦
const hotFocus = () => import('@/views/TingSheng/hotFocus.vue')
// 专家服务-热点聚焦-详情（弹窗）
const hotDetail = () => import('@/views/TingSheng/hotDetail.vue')
// 借力-最新龙虎榜
const newestCharts = () => import('@/views/JieLi/newestCharts.vue')
// 借力-龙虎密码
const DTCode = () => import('@/views/JieLi/DTCode.vue')
// 借力-游资图谱
const idleFund = () => import('@/views/JieLi/idleFund.vue')
// 借力-机构重仓
const orgAwk = () => import('@/views/JieLi/orgAwk.vue')
// 首页、自选股-资讯列表
const infoList = () => import('@/views/ZiXuanGu/infoList')
// 首页、自选股-【公告】【研报】详情
const infoDetail = () => import('@/views/ZiXuanGu/infoDetail')
// 首页-财源直播间
const liveHouse = () => import('@/views/Home/liveHouse')
// const news = () => import('@/views/Home/news')

// 首页-公告研报
// 自选股-【新闻】-详情
const newsDetail = () => import('@/views/Home/newsDetail')
//机构调研四个表格页面
const jgdy = () => import('@/views/jgdy/jgdy')
//板块列表--板块新闻
const bkxw = () => import('@/views/bklb/bkxw')
//板块列表--板块新闻
const bkgg = () => import('@/views/bklb/bkgg')
//板块列表--板块新闻
const bkyb = () => import('@/views/bklb/bkyb')
//高管交易榜
const ggjyb = () => import('@/views/ggjyb/ggjyb')
//涨停及炸版
const Limitup = () => import('@/views/JieLi/limitup/limitup')
//涨停及炸版
const Brandtable = () => import('@/views/JieLi/limitup/brandtable')
//热点策略
const hotTopic = () => import('@/views/strategy/hotTopic')
//主题策略
const zttz = () => import('@/views/strategy/zttz')
//资金揭秘
const zjjm = () => import('@/views/strategy/zjjm')
//价值策略
const jzcl = () => import('@/views/strategy/jzcl')
//app内嵌 主题报告详情页
const ztbgDetail = () => import('@/views/app/ztbg_detail')
const Page404 = () => import('@/components/page404')
// 免责声明
const disclaimer = () => import('@/views/declaration/disclaimer')
// 法律声明
const law = () => import('@/views/declaration/law')
const tszbComponent = () => import('@/views/strategy/tszbComponent')
const historyResultPop = () => import('@/views/strategy/historyResultPop')
const celueIntro = () => import('@/views/strategy/celueIntro')
//消息中心
const Message = () => import('@/views/message/message')
//app下载
const AppDownload = () => import('@/views/download/app-download')
//pc下载
const PcDownload = () => import('@/views/download/pc-download')
//pc下载页跳板
const PcDownloadBoard = () => import('@/views/download/board')
//app 收益统计
const Sytj = () => import('@/views/app/sytj')
//投诉建议
const Feedback = () => import('@/views/feedback/index')
//清空弹框
const popClearBox = () => import('@/views/strategy/popClearBox')
const ybclDetail = () => import('@/views/strategy/ybclDetail')
const bkDetail = () => import('@/views/bklb/bkDetail')
const jgDetail = () => import('@/views/jgdy/jgDetail')
const ztDetail = () => import('@/views/strategy/ztDetail')
// 营业部历史数据
const branchDetail = () => import('@/views/JieLi/branchDetail')
// 营业部上榜详情
const branchRankDetail = () => import('@/views/JieLi/branchRankDetail')
//日线 学指标弹窗视频
const xzbVideo = () => import('@/views/xzbVideo/index')
//安装完成页
const installFinish = () => import('@/views/download/installFinish')
//直播间回放页
const playBack = () => import('@/views/center/playback')
// 帮助说明书
const Help = () => import('@/views/help/index')
/**
 * 帮助说明书访问地址视频+PDF
 * /help/help3.pdf
 /help/help4.pdf
 /help/help5.pdf
 /help?pid=3
 /help?pid=4
 /help?pid=5
 *
 * */


Vue.use(Router)
let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      component: Page404
    },
    {
      path: '/app-download',
      component: AppDownload
    },
    {
      path: '/pc-download',
      component: PcDownload
    },
    {
      path: '/pc-download-board',
      component: PcDownloadBoard
    },
    {
      path: '/sytj',
      component: Sytj
    },
    {
      path: '/feedback',
      component: Feedback,
      meta: {
        title: '投诉建议'
      }
    },
    {
      path: '/helpvideo',
      component: Help,
      name: 'Help',
      meta: {
        title:'帮助说明书'
      }
    },
    {
      path: '/limitup',
      component: Limitup,
      name: 'Limitup',
      meta: {
        title:'市场情绪'
      }
    },
    {
      path: '/brandtable',
      component: Brandtable,
      name: 'Brandtable',
      meta: {
        title:'板块分析'
      }
    },
    {
      path: '/center/:p',
      component: Center,
      name: 'center',
      meta: {
        title:'用户中心'
      }
    },
    {
      path: '/ass/:p',
      component: Ass,
      name: 'ass',
      meta: {
        title:'风险测评'
      }
    },
    {
      path: '/growth/:p',
      name: 'growth',
      component: Growth
    },
    {
      path: '/videoplayer',
      name: 'videoplayer',
      component: Videoplayer
    },
    {
      path: '/selComponent',
      name: 'selComponent',
      component: selComponent
    },
    {
      path: '/tszbComponent',
      name: 'tszbComponent',
      component: tszbComponent
    },
    {
      path: '/historyResultPop',
      name: 'historyResultPop',
      component: historyResultPop
    },
    {
      path: '/celueIntro',
      name: 'celueIntro',
      component: celueIntro
    },
    {
      path: '/information/:p',
      component: information
    },
    {
      path: '/ybcl',
      component: ybcl
    },
    {
      path: '/hotTopic',
      component: hotTopic
    },
    {
      path: '/zttz',
      component: zttz
    },
    {
      path: '/zjjm',
      component: zjjm
    },
    {
      path: '/jzcl',
      component: jzcl
    },
    {
      path: '/expert_analyse',
      component: expertAnalyse
    },
    {
      path: '/tingsheng',
      component: expertService,
      children: [
        {
          path: '/viewpoint_live',
          component: viewpointLive,
          meta: { title: '观点直播' }
        },
        {
          path: '/early_know',
          component: earlyKnow,
          meta: { title: '早知晓FM' }
        },
        {
          path: '/expert_service_main',
          component: expertServiceMain,
          // meta: { title: '专家服务' }
          children: [
            {
              path: '/expert_online',
              component: expertOnline,
              meta: { title: '专家在线' }
            },
            {
              path: '/my_ques_answ',
              component: myQuesAnsw,
              meta: { title: '我的问答' }
            }
          ]
        },
        {
          path: '/live_lesson',
          component: liveLesson,
          meta: { title: '精品讲堂' }
        },
        {
          path: '/hot_focus',
          component: hotFocus,
          meta: { title: '热点聚焦' }
        }
      ]
    },
    {
      path: '/viewpoint_video',
      component: viewpointVideo
    },
    {
      path: '/viewpoint_image',
      component: viewpointImage
    },
    {
      path: '/class_recommend',
      component: classRecommend,
      meta: { title: '提问-课程推荐' }
    },
    {
      path: '/submit_question',
      component: submitQues,
      meta: { title: '提问-提交问题' }
    },
    {
      path: '/history_lesson',
      component: historyLesson,
      meta: { title: '直播课-往期回顾' }
    },
    {
      path: '/livelesson_play',
      component: liveLessonPlay,
      meta: { title: '直播课-视频播放' }
    },
    {
      path: '/ask_protocol',
      component: askProtocol,
      meta: { title: '提问-问答协议' }
    },
    {
      path: '/hot_detail/:timestamp',
      component: hotDetail,
      meta: { title: '热点聚焦-详情' }
    },
    {
      path: '/newest_charts',
      component: newestCharts,
      meta: { title: '龙虎榜-最新龙虎榜' }
    },
    {
      path: '/dt_code',
      component: DTCode,
      meta: { title: '龙虎榜-龙虎密码' }
    },
    {
      path: '/idle_fund',
      component: idleFund,
      meta: { title: '龙虎榜-游资图谱' }
    },
    {
      path: '/org_awk',
      component: orgAwk,
      meta: { title: '龙虎榜-机构重仓' }
    },
    {
      path: '/branch_detail',
      component: branchDetail,
      meta: { title: '营业部详情页' }
    },
    {
      path: '/branch_rank_reason',
      component: branchRankDetail,
      meta: { title: '上榜详情' }
    },
    {
      path: '/jgdy/:p',
      component: jgdy
    },
    {
      path: '/bkxw',
      component: bkxw
    },
    {
      path: '/bkgg',
      component: bkgg
    },
    {
      path: '/bkyb',
      component: bkyb
    },
    {
      path: '/ggjyb/:p',
      component: ggjyb
    },
    {
      path: '/info_list/:type', // 首页、自选股-资讯列表：0【新闻】 1【公告】 2【研报】
      component: infoList,
    },
    {
      path: '/live_house', // 首页直播间区域
      component: liveHouse
    },
    {
      path: '/info_detail/:type', // 首页、自选股-资讯详情: 0【新闻】 1【公告】 2【研报】
      component: infoDetail
    },
    {
      path: '/declaration_law', // 法律声明
      component: law
    },
    {
      path: '/declaration_disclaimer', // 免责声明
      component: disclaimer
    },
    {
      path: '/ztbg_detail',
      component: ztbgDetail
    },
    {
      path: '/message',
      name: 'message',
      component: Message
    },
    {
      path: '/popClearBox',
      name: 'popClearBox',
      component: popClearBox
    },
    {
      path: '/ybclDetail',
      name: 'ybclDetail',
      component: ybclDetail
    },
    {
      path: '/bkDetail',
      name: 'bkDetail',
      component: bkDetail
    },
    {
      path: '/jgDetail',
      name: 'jgDetail',
      component: jgDetail
    },
    {
      path: '/ztDetail',
      name: 'ztDetail',
      component: ztDetail
    },
    {
      path: '/xzbvideo',
      name: 'xzbVideo',
      component: xzbVideo,
      meta: { title: '指标用法' }
    },
    {
      path: '/installfinish',
      name: 'installFinish',
      component: installFinish,
      meta: { title: '安装完成' }
    },
    {
      path: '/playback',
      name: 'playBack',
      component: playBack,
      meta: { title: '' }
    },
    // {
    //   path: '/news/:page',
    //   component: news
    // },
    // {
    //   path: '/news_detail',
    //   component: newsDetail
    // },
  ]
})
// router.beforeEach((to,from,next) => {
//   next();
//   return
//
//   //用户权限
//   let pid = 0; // 0未登录 1游客登录、过期会员 3三星用户 4四星用户 5五星用户
//   try {
//     pid = to.query.pid;
//   } catch (e) {
//   }
//   let path = to.path;
//   let arr3 = [''];
//   let arr4 = [''];
//   let arr5 = ['/zjjm',];
//   if(arr3.includes(path)){
//     if(pid >= 3){
//       next()
//     }else{
//       return;
//     }
//   }else if(arr4.includes(path)){
//     if(pid >= 4){
//       next()
//     }else{
//       return;
//     }
//   }else if(arr5.includes(path)){
//     if(pid == 5){
//       next()
//     }else{
//       try {
//         ydClient.onClose();
//       } catch (e) {
//       }
//       return;
//     }
//   }else{
//     next();
//   }
//
// })
router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js